'use client';

import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  padding-top: 10px;

  user-select: none;
`;

const ImageWrapper = styled.div`
  width: 90px;
  height: 90px;
  position: absolute;
  top: 0;
  left: 10px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background-color: #fff;
  overflow: hidden;
  cursor: pointer;
`;

const MyPickInfoContainer = styled.div<{ $backgroundColor: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 90px;
  padding: 0 8px 0 112px;
  border-radius: 10px;
  background: ${({ $backgroundColor }) => $backgroundColor};
  cursor: pointer;
`;

const MyPickNameText = styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 140%;
  word-break: keep-all;
  overflow-wrap: break-word;
`;

const MyPickCardStyled = {
  Container,
  ImageWrapper,
  MyPickInfoContainer,
  MyPickNameText,
};

export default MyPickCardStyled;
